import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';
import heroImage from '../assets/hero.jpg';
import donkeyLogo from '../assets/donkey_logo.png';
import Hero from '../components/Hero';
import friedRiceImage from '../assets/food/friedRice.png';
import nashvilleChickenImage from '../assets/food/nashvilleHotChickenSandwich.png';
import nySteakImage from '../assets/food/nyStripSteak.png';
import FoodCarousel from '../components/FoodCarousel';
import Modal from '../components/Modal'; // Assuming we create a Modal component
import EightBallIcon from '../components/EightBallIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUtensils, faMicrophone } from '@fortawesome/free-solid-svg-icons';

const HomePage: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOrderClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="homepage">
      <Hero
        image={heroImage}
        height="60vh"
        useClipPath={true}
        showButton={true}
        buttonText="Order Online"
        onButtonClick={handleOrderClick}
        chevronLogo={donkeyLogo}
      />

      <main className="page-content">
        <section className="welcome-section text-center">
          <div className="container">
            <h1 className="section-title">Where Flavor Meets Fun</h1>
            <div className="icon-links">
              <Link to="/food-menu" className="icon-link">
                <FontAwesomeIcon icon={faUtensils} />
                <span>Food & Drinks</span>
              </Link>
              <Link to="/music" className="icon-link">
                <FontAwesomeIcon icon={faMicrophone} />
                <span>Karaoke</span>
              </Link>
              <Link to="/pool" className="icon-link">
                <EightBallIcon />
                <span>Pool</span>
              </Link>
            </div>
          </div>
        </section>

        <section className="featured-items-section">
          <div className="container">
            <h2 className="section-title text-center">Fan Faves</h2>
            <div className="featured-items-grid">
              <div className="featured-item text-center">
                <img src={friedRiceImage} alt="Fried Rice" />
                <div className="featured-item-text">
                  <h2>Fried Rice</h2>
                  <p>
                    Experience our signature fried rice — a local favorite here at Burbank's Bites and Billiards in San Jose. Perfectly seasoned jasmine rice wok-tossed with fresh vegetables, scrambled eggs, and your choice of protein, creating a harmonious blend of flavors and textures. Each grain is infused with our special sauce blend, delivering that authentic taste that keeps our customers coming back. It's comfort food with a delicious twist that hits the spot every time.
                  </p>
                </div>
              </div>
              <div className="featured-item text-center reverse">
                <img src={nashvilleChickenImage} alt="Nashville Chicken Sandwich" />
                <div className="featured-item-text">
                  <h2>Nashville Chicken Sandwich</h2>
                  <p>
                    Fire up your taste buds with our Nashville Chicken Sandwich — a spicy sensation that's become a must-try at Burbank's Bites and Billiards. Featuring a crispy, hand-breaded chicken breast coated in our signature Nashville hot seasoning, topped with cool pickles and creamy slaw, all served on a toasted brioche bun. The perfect balance of heat and flavor that'll leave you craving more. Come taste why San Jose can't get enough of this fiery favorite!
                  </p>
                </div>
              </div>
              <div className="featured-item text-center">
                <img src={nySteakImage} alt="NY Steak & Potato" />
                <div className="featured-item-text">
                  <h2>NY Steak & Potato</h2>
                  <p>
                    Indulge in our premium NY Steak & Potato — a hearty classic that's earned its place as a fan favorite at Burbank's Bites and Billiards. Featuring a perfectly grilled New York strip steak, seasoned to perfection and cooked to your liking, paired with our signature loaded potato. Rich, satisfying, and expertly prepared, this dish delivers the steakhouse experience you crave. Come discover why locals consider this one of San Jose's best steak dinners.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FoodCarousel />

        <section className="order-online-section">
          <div className="container text-center">
            <h2>Ready to Order?</h2>
            <p>Hungry for our delicious food? Place your order online and we'll have it ready for pickup or delivery!</p>
            <button className="order-online-button" onClick={handleOrderClick}>
              Order Online Now
            </button>
          </div>
        </section>
      </main>

      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <h2>Order Options</h2>
        <div className="order-options">
          <a
            href="https://www.doordash.com/store/burbanks-bites-and-billiards-san-jose-30824057/41782748/?srsltid=AfmBOoqakBiJvAZzFLZRZGufNP_gk0iTxmRdiI5ZHc9EhLGTTLS-AR41"
            target="_blank"
            rel="noopener noreferrer"
            className="order-option-button doordash"
          >
            Order on DoorDash
          </a>
          <a href="tel:+14083202466" className="order-option-button call-us">
            Call to Order
            <span className="phone-number">(408) 320-2466</span>
          </a>
        </div>
      </Modal>
    </div>
  );
};

export default HomePage; 